import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BarChart2, Target, Shield } from 'lucide-react';
const modules = [{
  badge: 'MÓDULO 1',
  icon: BarChart2,
  title: 'La Dieta Cognitiva',
  description: 'Cómo equilibrar el mundo digital y el humano para fortalecer el liderazgo natural de tu hijo. Un sistema probado para maximizar el potencial sin sacrificar la infancia.',
  color: '#0EA5E9'
}, {
  badge: 'MÓDULO 2',
  icon: Target,
  title: 'Ingeniería de Instrucciones para Niños',
  description: 'El arte de pedir lo que quieres — la habilidad mejor pagada del siglo XXI. Enseña a tu hijo a dominar el prompting y convertirse en el arquitecto de sus resultados.',
  color: '#818CF8'
}, {
  badge: 'MÓDULO 3',
  icon: Shield,
  title: 'El Escudo de Resiliencia',
  description: 'Cómo formar un carácter insustituible que ninguna máquina pueda replicar. El diferenciador humano definitivo en un mundo de algoritmos.',
  color: '#38BDF8'
}];
export function WhatInsideSection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    backgroundColor: '#050A14'
  }} data-id="element-265">
      <div className="max-w-5xl mx-auto" data-id="element-266">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-xs font-black tracking-widest uppercase mb-5 text-center" style={{
        color: '#0EA5E9'
      }} data-id="element-267">
          QUÉ ENCONTRARÁS DENTRO
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="text-4xl md:text-5xl font-black text-center mb-4 leading-tight" style={{
        color: '#F1F5F9'
      }} data-id="element-268">
          El Sistema{' '}
          <span style={{
          background: 'linear-gradient(90deg, #0EA5E9, #818CF8)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-269">
            L-Code
          </span>{' '}
          en 3 Módulos
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-lg text-center mb-14 max-w-2xl mx-auto" style={{
        color: '#94A3B8'
      }} data-id="element-270">
          Cada módulo está diseñado para ser implementado en familia, con
          ejercicios prácticos y resultados medibles.
        </motion.p>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-271">
          {modules.map((mod, i) => {
          const Icon = mod.icon;
          return <motion.div key={mod.badge} initial={{
            opacity: 0,
            y: 50
          }} animate={inView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.7,
            delay: 0.2 + i * 0.15
          }} whileHover={{
            scale: 1.02,
            y: -6
          }} className="rounded-2xl overflow-hidden flex flex-col" style={{
            backgroundColor: '#0C1628',
            border: `1px solid ${mod.color}18`,
            borderTop: `3px solid ${mod.color}`
          }} data-id="element-272">
                <div className="p-7 flex-1" data-id="element-273">
                  <div className="flex items-center justify-between mb-6" data-id="element-274">
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{
                  backgroundColor: `${mod.color}12`,
                  border: `1px solid ${mod.color}25`
                }} data-id="element-275">
                      <Icon size={24} style={{
                    color: mod.color
                  }} data-id="element-276" />
                    </div>
                    <span className="text-xs font-black tracking-widest px-3 py-1 rounded-full" style={{
                  backgroundColor: `${mod.color}12`,
                  color: mod.color
                }} data-id="element-277">
                      {mod.badge}
                    </span>
                  </div>
                  <h3 className="text-lg font-black mb-3" style={{
                color: '#F1F5F9'
              }} data-id="element-278">
                    {mod.title}
                  </h3>
                  <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-279">
                    {mod.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}